import { render, staticRenderFns } from "./ScenarioRanking.vue?vue&type=template&id=2ada0f72&"
import script from "./ScenarioRanking.vue?vue&type=script&lang=js&"
export * from "./ScenarioRanking.vue?vue&type=script&lang=js&"
import style0 from "./ScenarioRanking.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports